export default __webpack_public_path__ + "static/media/number1.24500663.svg";